module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-4-photo-10-0792065c34d8bea38bcc7dff81cf8ede.webp";